/* This file is autogenerated, see readme.md for instructions */
import UnlinkSvgIcon from '@bloomreach/banana-theme/icons/unlink.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const UnlinkIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <UnlinkSvgIcon />
    </Icon>
  );
});

UnlinkIcon.displayName = 'UnlinkIcon';

export default UnlinkIcon;
